import { request } from './request';
import { getUrlQuery } from './core';
import { setExpFromHeader } from '../../common/js/experiment.js';

/* global getCurrentPages swan getApp */
// service 请求链接
import { HOSTS } from './env';
let QUESTION_API = HOSTS && HOSTS.swan + '/swan/ajax/question';
QUESTION_API = '/swan/ajax/question';
let LAWCODE_API = HOSTS && HOSTS.falv + '/falv/lawcodex/landpage/content';
LAWCODE_API = '/falv/lawcodex/landpage/content';
/**
 * 解析query并请求qb页核心数据
 * 提取此方法的原因是为了尽可能早的发送qb页请求，可能在app.js中执行，也可能在page.js中执行
 * 目前的顺序是page.onPrefetch => app.onLaunch => page.onInit => page.onLoad
 * @param opt {Object} 方法传入的参数
 * @param opt.query {Object} url中的query参数
 * @param opt.data {Object} 请求参数
 * @param opt.customSuccCb {Function} 自定义成功回调，可以不依赖Promise执行
 * @param opt.customFailCb {Function} 自定义失败回调，可以不依赖Promise执行
 * @param opt.isSqb {boolean} 是否为单qb页核心请求
 * @retrun {Promise} 请求的Promise
 */

export const reqQbData = (opt = {}) => {
  const app = getApp();
  const query = opt.query || {};
  const data = opt.data || {};
  // return new Promise((resolve, reject) => {
  let qid = query.qid;
  if (query.qid && query.qid.indexOf('.') >= 0) {
    qid = query.qid.split('.')[0];
  }
  let rid = query.rid;
  // 单qb页
  // 手百搜索DQA挖掘，url传过来的searchRid，把该条searchRid置顶，且只显示一次，加载更多不在显示
  query.searchRid && (data.searchRid = query.searchRid);
  data.fromPage = 'squestion';
  data.sfrom = 'lvlin';
  data.lvlinSource = 'wap';
  // 解析参数
  data.trid = rid;
  data.qid = qid;
  query.word && (data.word = query.word);
  // 实验相关参数

  let UrlQuery = getUrlQuery();
  ['hitEid', 'hitExp', 'samp_hit'].forEach(item => {
    let val = query[item] || UrlQuery && UrlQuery[item];
    val && (data[item] = val);
  });
  return request({
    url: QUESTION_API,
    data,
    loginNeeded: false,
    needBduss: true
  });
};

// 新法典请求数据接口
export const reqCcData = (opt = {}) => {
  const query = opt.query || {};
  const data = opt.data || {};
  // 解析参数
  data.sfrom = 'lvlin';
  data.articleID = query && query.articleId || '';
  return request({
    url: LAWCODE_API,
    data,
    loginNeeded: false,
    needBduss: true
  });
};